import { useEffect, useState } from 'react'

/**
 * Tracks which full-height scene is currently crossing the middle of the
 * viewport, so the reel indicator can highlight the active frame.
 */
export function useActiveScene(ids: string[]): string {
  const [active, setActive] = useState<string>(ids[0] ?? '')
  const key = ids.join('|')

  useEffect(() => {
    const elements = key
      .split('|')
      .map(id => document.getElementById(id))
      .filter((el): el is HTMLElement => Boolean(el))

    if (elements.length === 0) return

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) setActive(entry.target.id)
        })
      },
      { rootMargin: '-49% 0px -49% 0px', threshold: 0 }
    )

    elements.forEach(el => observer.observe(el))
    return () => observer.disconnect()
  }, [key])

  return active
}
